(() => {
  if (window.AceiiInstallmentOptionsV2) return;
  window.AceiiInstallmentOptionsV2 = true;

  const selector = "[data-aceii-installment-options]";

  const findProductScope = (root) =>
    root.closest("[data-aceii-mobile-product-layout]") ||
    root.closest('[id^="product-info-"]') ||
    root.closest(".hdt-product__info-container") ||
    root;

  const arrangeRows = (root, productScope) => {
    const body = root.querySelector("[data-aceii-installment-body]");
    const paypalRow =
      root.querySelector("[data-pp-message]") ||
      productScope.querySelector("[data-pp-message]");

    if (!body) return false;

    if (paypalRow && paypalRow.parentElement !== body) {
      body.append(paypalRow);
    } else if (paypalRow && body.lastElementChild !== paypalRow) {
      body.append(paypalRow);
    }

    return Boolean(
      paypalRow &&
      paypalRow.parentElement === body &&
      body.lastElementChild === paypalRow
    );
  };

  const bindDisclosureAnimation = (root) => {
    const details = root.querySelector(".aceii-installment-options__card");
    const summary = details?.querySelector(".aceii-installment-options__summary");
    const body = details?.querySelector("[data-aceii-installment-body]");

    if (!details || !summary || !body) return;

    summary.addEventListener("click", (event) => {
      if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

      event.preventDefault();

      if (details.classList.contains("is-animating")) return;

      const isOpening = !details.open;

      if (isOpening) details.open = true;

      const collapsedHeight = summary.offsetHeight;
      const expandedHeight = collapsedHeight + body.scrollHeight;
      const startHeight = isOpening ? collapsedHeight : details.offsetHeight;
      const endHeight = isOpening ? expandedHeight : collapsedHeight;

      details.classList.add("is-animating", isOpening ? "is-opening" : "is-closing");
      details.style.height = `${startHeight}px`;

      let timeoutId;
      const finish = (transitionEvent) => {
        if (
          transitionEvent &&
          (transitionEvent.target !== details || transitionEvent.propertyName !== "height")
        ) {
          return;
        }

        details.removeEventListener("transitionend", finish);
        window.clearTimeout(timeoutId);

        if (!isOpening) details.open = false;

        details.classList.remove("is-animating", "is-opening", "is-closing");
        details.style.height = "";
      };

      details.addEventListener("transitionend", finish);
      timeoutId = window.setTimeout(finish, 650);

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          if (isOpening) details.classList.remove("is-opening");
          details.style.height = `${endHeight}px`;
        });
      });
    });
  };

  const initialize = (root) => {
    if (!(root instanceof Element) || root.dataset.aceiiInstallmentInitialized === "true") return;

    root.dataset.aceiiInstallmentInitialized = "true";
    bindDisclosureAnimation(root);

    const productScope = findProductScope(root);
    window.setTimeout(() => {
      if (!root.isConnected) return;

      arrangeRows(root, productScope);

      const observer = new MutationObserver(() => arrangeRows(root, productScope));
      observer.observe(productScope, { childList: true, subtree: true });
      window.setTimeout(() => observer.disconnect(), 15000);
    }, 1000);
  };

  const scan = (scope = document) => {
    if (scope instanceof Element && scope.matches(selector)) initialize(scope);
    scope.querySelectorAll?.(selector).forEach(initialize);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => scan(), { once: true });
  } else {
    scan();
  }

  document.addEventListener("shopify:section:load", (event) => scan(event.target));
  document.addEventListener("variant-change", () => requestAnimationFrame(() => scan()));
})();
